import axios from 'axios';
import { isTokenExpired } from './common.js';
import { actionCreatorsFactory, asyncActionType, createActionTypes } from '../utils/action-helpers.js';
import { sendSentryError } from '../setup/sentry';

// Action types
export const GoogleAuthActionTypes = createActionTypes('GoogleAuth', [
  asyncActionType('CONNECT_GOOGLE_ACCOUNT'),
  asyncActionType('CHECK_GOOGLE_STATUS'),
  asyncActionType('DISCONNECT_GOOGLE_ACCOUNT')
]);

// Action creators
export const connectGoogleAccountActions = actionCreatorsFactory(
  [
    GoogleAuthActionTypes.CONNECT_GOOGLE_ACCOUNT,
    GoogleAuthActionTypes.CONNECT_GOOGLE_ACCOUNT_SUCCESS,
    GoogleAuthActionTypes.CONNECT_GOOGLE_ACCOUNT_FAIL
  ],
  'connectGoogleAccount'
);

export const checkGoogleStatusActions = actionCreatorsFactory(
  [GoogleAuthActionTypes.CHECK_GOOGLE_STATUS, GoogleAuthActionTypes.CHECK_GOOGLE_STATUS_SUCCESS, GoogleAuthActionTypes.CHECK_GOOGLE_STATUS_FAIL],
  'checkGoogleStatus'
);

export const disconnectGoogleAccountActions = actionCreatorsFactory(
  [
    GoogleAuthActionTypes.DISCONNECT_GOOGLE_ACCOUNT,
    GoogleAuthActionTypes.DISCONNECT_GOOGLE_ACCOUNT_SUCCESS,
    GoogleAuthActionTypes.DISCONNECT_GOOGLE_ACCOUNT_FAIL
  ],
  'disconnectGoogleAccount'
);

/**
 * Start the Google OAuth process
 */
export function startGoogleConnect(token) {
  return async (dispatch) => {
    try {
      dispatch(connectGoogleAccountActions.connectGoogleAccount());

      const headers = { Authorization: `Token ${token}` };
      const response = await axios.get('/api/auth/google/start/', { headers });

      // Open the authorization URL in a popup
      const width = 500;
      const height = 600;
      const left = window.screenX + (window.outerWidth - width) / 2;
      const top = window.screenY + (window.outerHeight - height) / 2;

      window.open(response.data.authorization_url, 'google-oauth', `width=${width},height=${height},left=${left},top=${top}`);

      return response;
    } catch (err) {
      if (!isTokenExpired(dispatch, err)) {
        sendSentryError({ err, context: 'startGoogleConnect' });
        dispatch(connectGoogleAccountActions.connectGoogleAccountFail(err));
      }
    }
  };
}

/**
 * Check the status of Google connection
 */
export function checkGoogleStatus(token) {
  return async (dispatch) => {
    try {
      dispatch(checkGoogleStatusActions.checkGoogleStatus());

      const headers = { Authorization: `Token ${token}` };
      const response = await axios.get('/api/users/google-connect/status/', { headers });

      console.log('Google status response:', response.data);

      dispatch(checkGoogleStatusActions.checkGoogleStatusSuccess(response.data));
      return response;
    } catch (err) {
      if (!isTokenExpired(dispatch, err)) {
        sendSentryError({ err, context: 'checkGoogleStatus' });
        dispatch(checkGoogleStatusActions.checkGoogleStatusFail(err));
      }
    }
  };
}

/**
 * Disconnect Google account
 */
export function disconnectGoogleAccount(token) {
  return async (dispatch) => {
    try {
      dispatch(disconnectGoogleAccountActions.disconnectGoogleAccount());

      const headers = { Authorization: `Token ${token}` };
      const response = await axios.delete('/api/users/google-connect/', { headers });

      dispatch(disconnectGoogleAccountActions.disconnectGoogleAccountSuccess(response.data));
      return response;
    } catch (err) {
      if (!isTokenExpired(dispatch, err)) {
        sendSentryError({ err, context: 'disconnectGoogleAccount' });
        dispatch(disconnectGoogleAccountActions.disconnectGoogleAccountFail(err));
      }
    }
  };
}
